export const HelpCalender = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_6171_27095)">
      <path
        d="M4 6H3C2.4485 6 2 6.4485 2 7V8C2 8.5515 2.4485 9 3 9H4C4.5515 9 5 8.5515 5 8V7C5 6.4485 4.5515 6 4 6ZM3 8V7H4V8H3ZM9.5 1H9V0.5C9 0.224 8.7765 0 8.5 0C8.2235 0 8 0.224 8 0.5V1H4V0.5C4 0.224 3.7765 0 3.5 0C3.2235 0 3 0.224 3 0.5V1H2.5C1.1215 1 0 2.1215 0 3.5V9.5C0 10.8785 1.1215 12 2.5 12H9.5C10.8785 12 12 10.8785 12 9.5V3.5C12 2.1215 10.8785 1 9.5 1ZM2.5 2H9.5C10.327 2 11 2.673 11 3.5V4H1V3.5C1 2.673 1.673 2 2.5 2ZM9.5 11H2.5C1.673 11 1 10.327 1 9.5V5H11V9.5C11 10.327 10.327 11 9.5 11Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6171_27095">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
